import axios from "axios";

// import Cookies from 'js-cookie'

// const ticket = Cookies.get('test')

export const request = config => {
  return axios(config)
}

let cancel

axios.create({
  responseType: "json",

  withCredentials: true, // 设置 withCredentials 使请求带上 `cookies`

  cancelToken: new axios.CancelToken(function(c) {
    cancel = c // 记录当前请求的取消方法
  })
})

axios.defaults.retry = 3

axios.defaults.retryDelay = 2000

var promiseArr = {}// 用于记录每个请求的取消方法

// http request 拦截器

axios.interceptors.request.use(
  function(config) {
    // 在发送请求之前做某事

    // config.headers['url'] = window.location.href

    // config.headers['ticket'] = ticket

    //config.headers["X-Requested-With"] = "XMLHttpRequest";

    if (promiseArr[config.url]) {
      promiseArr[config.url]("操作取消");

      promiseArr[config.url] = cancel;
    } else {
      promiseArr[config.url] = cancel;
    }

    return config;
  },
  function(error) {
    // 请求错误时做些事

    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  response => {
    return response;
  },

  error => {
    console.log("err" + error) // for debug

    // Message({

    // message: error.message,

    // type: 'error',

    // duration: 5 * 1000

    // })

    return Promise.reject(error)
  }
)

// 在API文件中 防止无限多次请求

axios.interceptors.response.use(undefined, function axiosRetryInterceptor(err) {
  var config = err.config

  // If config does not exist or the retry option is not set, reject

  if (!config || !config.retry) return Promise.reject(err)

  // Set the variable for keeping track of the retry count

  config.__retryCount = config.__retryCount || 0

  // Check if we've maxed out the total number of retries

  if (config.__retryCount >= config.retry) {
    // Reject with the error

    return Promise.reject(err)
  }

  // Increase the retry count

  config.__retryCount += 1;

  // Create new promise to handle exponential backoff

  var backoff = new Promise(function(resolve) {
    setTimeout(function() {
      resolve();
    }, config.retryDelay || 1);
  })

  // Return the promise in which recalls axios to retry the request

  return backoff.then(function() {
    return axios(config)
  })
})



// WEBPACK FOOTER //
// ./src/utils/httpAxios.js